import { render, staticRenderFns } from "./BSF.vue?vue&type=template&id=52b88109&"
import script from "./BSF.vue?vue&type=script&lang=js&"
export * from "./BSF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports